<seds-modal class="user-add-success-modal">
  <div header class="modal-header">
    <div class="modal-header__title-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M8.6 11.8L6.45 9.65C6.26667 9.46667 6.03333 9.375 5.75 9.375C5.46667 9.375 5.23333 9.46667 5.05 9.65C4.86667 9.83333 4.775 10.0667 4.775 10.35C4.775 10.6333 4.86667 10.8667 5.05 11.05L7.9 13.9C8.1 14.1 8.33333 14.2 8.6 14.2C8.86667 14.2 9.1 14.1 9.3 13.9L14.95 8.25C15.1333 8.06667 15.225 7.83333 15.225 7.55C15.225 7.26667 15.1333 7.03333 14.95 6.85C14.7667 6.66667 14.5333 6.575 14.25 6.575C13.9667 6.575 13.7333 6.66667 13.55 6.85L8.6 11.8ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
          fill="#1B7749"
        />
      </svg>
      <span class="modal-header__title">Usuários criados!</span>
    </div>
  </div>
  <div content class="modal-content">
    <p class="modal-content__message">
      Deu tudo certo com o envio dos acessos. Em cerca de 15 minutos sua lista
      de usuários deve estar atualizada.
    </p>
    <p class="modal-content__message--bold">
      Os novos usuários vão receber as instruções de cadastro e ativação por
      e-mail.
    </p>

    @if (results.length > 0) {
      <ul class="modal-content__list">
        @for (result of results; track result.email) {
          <li class="modal-content__list-item">
            Logon {{ result.response?.logon }} - {{ result.email }} - {{ result.name }}
          </li>
        }
      </ul>
    }
  </div>
</seds-modal>
